/* ═══════════════════════════════════════════════════════════════
   HERBAL CUP TEA — Blog Page Script
   Category Tabs, URL Hash Routing, Article Progress Bar
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════
     CATEGORY FILTER TABS (Blog Index)
     ═══════════════════════════════════════════ */
  var tabs  = document.querySelectorAll('.blog-filter__tab');
  var cards = document.querySelectorAll('.blog-card');

  function activateTab(category) {
    /* Update tab UI */
    tabs.forEach(function (t) {
      var isActive = t.dataset.category === category;
      t.classList.toggle('active', isActive);
      t.setAttribute('aria-selected', String(isActive));
    });

    /* Show / hide cards */
    cards.forEach(function (card) {
      card.hidden = (category !== 'all' && card.dataset.category !== category);
    });

    /* Update URL hash */
    if (category !== 'all') {
      history.replaceState(null, '', '#' + category);
    } else {
      history.replaceState(null, '', window.location.pathname);
    }
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      activateTab(tab.dataset.category);
    });
  });

  /* Keyboard: arrow keys between tabs */
  tabs.forEach(function (tab, index) {
    tab.addEventListener('keydown', function (e) {
      var newIndex;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        newIndex = (index + 1) % tabs.length;
        tabs[newIndex].focus();
        tabs[newIndex].click();
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        newIndex = (index - 1 + tabs.length) % tabs.length;
        tabs[newIndex].focus();
        tabs[newIndex].click();
      }
    });
  });

  /* Hash routing */
  function handleHash() {
    var hash = window.location.hash.slice(1);
    if (!hash) return;
    var matchingTab = document.querySelector('.blog-filter__tab[data-category="' + hash + '"]');
    if (matchingTab) activateTab(hash);
  }

  handleHash();
  window.addEventListener('hashchange', handleHash);


  /* ═══════════════════════════════════════════
     ARTICLE PROGRESS BAR
     ═══════════════════════════════════════════ */
  var progressBar = document.getElementById('article-progress-bar');
  var articleBody = document.querySelector('.article-body');

  if (progressBar && articleBody) {
    window.addEventListener('scroll', function () {
      var rect       = articleBody.getBoundingClientRect();
      var bodyTop    = rect.top + window.scrollY;
      var bodyHeight = rect.height;
      var scrolled   = window.scrollY - bodyTop + window.innerHeight * 0.5;
      var progress   = Math.min(Math.max(scrolled / bodyHeight, 0), 1);
      progressBar.style.width = (progress * 100) + '%';
    }, { passive: true });
  }

})();
